export const ManageAdminDashBoard = "/dashboard";
export const AdminCreateContent = "/adminhomepage/adminmangecategories";
export const AdminCreateCategories = "/admincreatecategories";
export const CreateCategory = "/admincreatecategories/createcategory";

export const AdminManageUserProfile = "/instructors";
export const AdminViewSpecificCategory = "/admincreatecategories/viewcategory";
export const AdminCreateInterest = "/admincreatecategories/createinterest";
export const AdminEditCategory = "/admincreatecategories/edit";

export const AdminVerifiedDashBoard = "/verifiedcontents";
export const AdminViewVerifiedContent = "/contents";
export const AdminEvents = "/events";

export const UserLandingPage = "/userhomepage";

export const SystemSettingPage = "/systemsetting";

export const DisplaySpecificContent = "/adminallposts/displaypost";
export const UserBlogPost = "/blogpost";

export const CreateInterest = "/interests";
export const CreateActivities = "/activities";
export const ApprovedContents = "/approvedcontents";
export const ViewEventsAttendees = "/eventsattendees";
export const AdminBanner = "/banners";

/* Deals */
export const ManageDealsPage = "/deals";
export const ManageDealsCategoryPage = "/deals-categories";

/* Merchants */
export const ManageMerchantsPage = "/merchants";
export const ManageMerchantLocationPage = "/merchants-locations";

/**FOOD LIBRARY */
export const AdminFoodLibrary = "/food-library";
export const DraftMealPlans = "/meal-plan-drafts";
export const PublishMealPlans = "/meal-plan-publish";
export const viewSpecificMealPlans = "/meal-plan-view";
export const AdminViewPendingMealPlans = "/admin-pending-meal-plans";
export const AdminViewSpecificDailyMealPlans = "/admin-view-meal-plans";
export const MealPlansConfigs = "/config-meal-plans";

/**   USER CONSTANTS */

export const UserPublishedContents = "/dashboard";

export const UserDrafts = "/userdrafts";

export const UserUploadContents = "/useruploadcontents";

export const UserSpecificContents = "/userspecificcontents";

export const MealPLanPage = "/meal-plan";
export const UserEditMealPlan = "/edit-meal-plan";
export const ManageAllMealPlansPage = "/managed-meal-plans";

/** ERRORS CONSTANTS */
export const ErrorPage = "/";
